// no op
export const hapticFeedback = (): Promise<void> => Promise.resolve()
